import { extend } from 'vee-validate';
import { required, email, confirmed, numeric, length, min } from 'vee-validate/dist/rules';

extend('required', required);
extend('email', email);
extend('required_select', required);
extend('verify_password', confirmed);
extend('numeric', numeric);
extend('length', length);
extend('min', min);
